export default "__VITE_ASSET__DPT_stmI__"